import _ from 'lodash';
import { validateEventConflicts } from './conflict-validator';
import { validateAudioCuesheetURL, validateCuesheetURL } from './cuesheets-validator';
import { validateEventDescription } from './description-validator';
import { validateEventBackground } from './event-background-validator';
import { validateEventLeadtimeAcknowledge } from './leadtime-acknwoledge-validator';
import { validateEventLocation } from './location-validator';
import { validateMobileEventConflicts } from './mobile-conflict-validator';
import { validateMobileEventDescription } from './mobile-description-validator';
import { validateMobileEventLocation } from './mobile-location-validator';
import { validateMobileEventTitle } from './mobile-title-validator';
import { validateEventNotes } from './notes-validator';
import { validateEventPassword } from './password-validator';
import { validateRedirectUrl } from './redirect-url-validator';
import { validateSlides } from './slides-validator';
import { validateEventTitle } from './title-validator';
import { validateEventType } from './type-validator';
import { EventValidator } from './types';
import { validateZoomDetails } from './zoom-validator';

export const validateEventUpdate = ({
  events,
  existingEvent,
  existingMobileEvent,
  eventUpdate,
  leadTime,
  simulatedLiveAssetIsUpload,
  cueSheetURL,
  audioCueSheetURL,
  timezone,
  isAdmin,
  isProd = true
}: EventValidator.EventUpdateProps): EventValidator.Errors => {

  const isProducedAndMobileFlow = eventUpdate.type === EventValidator.ProductionType.PRODUCED_AND_MOBILE_KIT ||
      eventUpdate.type === EventValidator.ProductionType.PRODUCED_AND_MOBILE_APP;

  const errors: EventValidator.Errors = {
    ...validateEventType(eventUpdate),
    ...validateEventTitle(eventUpdate),
    ...validateEventLocation(eventUpdate),
    ...validateEventDescription(eventUpdate),
    ...validateEventBackground(eventUpdate),
    ...validateEventNotes(eventUpdate),
    ...validateZoomDetails(eventUpdate),
    ...validateEventPassword(eventUpdate),
    ...validateCuesheetURL(cueSheetURL),
    ...validateRedirectUrl(eventUpdate),
    ...validateAudioCuesheetURL(audioCueSheetURL),
    ...validateEventLeadtimeAcknowledge(eventUpdate),
    ...validateSlides(eventUpdate)
  };

  if (isProducedAndMobileFlow) {
      _.merge(errors, validateMobileEventTitle(eventUpdate));
      _.merge(errors, validateMobileEventLocation(eventUpdate));
      _.merge(errors, validateMobileEventDescription(eventUpdate));
    }

  if (_.isEmpty(errors.date)) {
    _.merge(
      errors,
      validateEventConflicts({
        newEventInfo: eventUpdate,
        events,
        existingEvent,
        simulatedLiveAssetIsUpload,
        leadTime,
        timezone,
        isAdmin,
        isProd
      })
    );
  }

  if (_.isEmpty(errors.mobileDate) && isProducedAndMobileFlow) {
      _.merge(
        errors,
        validateMobileEventConflicts({
          newEventInfo: eventUpdate,
          simulatedLiveAssetIsUpload,
          events,
          timezone,
          isAdmin,
          isProd,
          isProducedAndMobileFlow,
          existingEvent: existingMobileEvent
        })
      );
    }


  return errors;
};
